/** 
 * Class to hold references to the different height levels of the gauge bottom drawer
 */
export class DrawerLevels {
  static FULL = 'full';
  static HALF = 'half';
  static MIN = 'min'; 
}